import { Issue, useIssue } from '@gripp/shared-logic';
import {
  BottomComponentBar,
  LoadingIndicator,
  ReassignModal,
  SlideAction,
} from '@gripp/shared-ui';
import { View } from 'react-native';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const ActivityReassignColumn = () => {
  const { issueId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { issue, isLoading } = useIssue(issueId ?? '');

  const hide = () => {
    const currentState =
      location.state && typeof location.state === 'object'
        ? (location.state as Record<string, unknown>)
        : {};

    navigate('..', {
      relative: 'path',
      state: {
        ...currentState,
        slideLayoutInitialTransition: SlideAction.PREV,
      },
    });
  };

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <ReassignModal
      visible={true}
      hide={hide}
      issue={issue as Issue}
      presentWebStyle={true}
      bottomBar={({ onRightPress: _omit, ...props }) => (
        <View
          style={{
            marginHorizontal: 16,
          }}
        >
          <BottomComponentBar {...props} backButton={null} />
        </View>
      )}
    />
  );
};
